// Safe localStorage access. Edge "tracking prevention" / private modes can throw
// a SecurityError on access, which would otherwise crash the whole app at mount.
export function getStored(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setStored(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage unavailable - ignore */
  }
}

export function removeStored(key) {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* storage unavailable - ignore */
  }
}
